import { ChevronLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

/** Условия использования Delo. Официальный документ — обращение на «Вы». */
export function Terms() {
  return (
    <div className="flex flex-col min-h-full page-enter">
      <div className="sticky top-0 sticky-header z-10 px-4 pt-5 pb-3">
        <Link
          to="/profile"
          className="btn-active inline-flex items-center gap-1 text-sm text-ink-1 mb-2"
        >
          <ChevronLeft size={16} /> Профиль
        </Link>
        <p className="text-h1 text-ink">Условия использования</p>
        <p className="text-sm text-ink-2 mt-0.5">Версия от 22.07.2026</p>
      </div>

      <div className="flex-1 px-4 pb-6 space-y-4">
        <Section title="1. Общие положения">
          Настоящие Условия регулируют порядок использования сервиса Delo — Telegram-бота
          @DeloAppBot и связанного веб-приложения, размещённого по адресу deloapp.online
          (далее — Сервис).
          {' '}
          Правообладатель и администратор Сервиса — самозанятый Захаров Семён Алексеевич,
          ИНН 771874983254 (далее — Администрация). Адрес для обращений: my@zakharovsem.ru.
          {' '}
          Начиная использование Сервиса, Пользователь принимает настоящие Условия в полном
          объёме. При несогласии с любым положением использование Сервиса должно быть прекращено.
          {' '}
          Порядок приобретения платных подписок регулируется отдельным документом — публичной
          офертой, размещённой по адресу deloapp.online/offer.
        </Section>

        <Section title="2. Возрастные ограничения">
          Сервис предназначен для лиц, достигших восемнадцатилетнего возраста. Начиная
          использование Сервиса, Пользователь подтверждает, что достиг указанного возраста.
          Ответственность за достоверность данного подтверждения несёт Пользователь.
        </Section>

        <Section title="3. Учётная запись">
          Учётная запись создаётся автоматически при первом обращении к Сервису и связывается
          с аккаунтом Пользователя в мессенджере Telegram.
          {' '}
          Пользователь несёт ответственность за сохранность доступа к своему аккаунту Telegram
          и за все действия, совершённые в Сервисе с его использованием.
          {' '}
          Передача доступа к учётной записи третьим лицам не допускается.
        </Section>

        <Section title="4. Функциональность Сервиса">
          Сервис предоставляет возможность вести диалог в текстовой и голосовой форме, сохранять
          сведения о Пользователе для использования в последующих обращениях, создавать
          напоминания, задачи и события календаря, подключать сторонние сервисы электронной почты
          и календарей, осуществлять поиск информации в сети Интернет.
          {' '}
          Объём доступной функциональности определяется тарифным планом Пользователя. Актуальное
          описание тарифов размещается в Сервисе.
          {' '}
          Администрация вправе изменять состав функциональности, вводить новые возможности
          и прекращать поддержку существующих, уведомляя Пользователей через Сервис.
        </Section>

        <Section title="5. Допустимое использование">
          При использовании Сервиса запрещается:
          <List items={[
            'осуществлять деятельность, нарушающую законодательство Российской Федерации;',
            'направлять сообщения, содержащие угрозы, оскорбления, призывы к насилию или дискриминации;',
            'использовать Сервис для рассылки сообщений без согласия получателей;',
            'создавать материалы, нарушающие права третьих лиц, включая права на результаты интеллектуальной деятельности;',
            'предпринимать действия, направленные на обход установленных ограничений, нарушение работоспособности Сервиса или получение несанкционированного доступа;',
            'использовать Сервис посредством автоматизированных средств, за исключением предусмотренных функциональностью;',
            'создавать множественные учётные записи с целью обхода ограничений бесплатного тарифа.',
          ]} />
          Нарушение настоящего пункта влечёт блокировку доступа к Сервису без возврата денежных
          средств.
        </Section>

        <Section title="6. Подключение сторонних сервисов">
          Сервис предоставляет возможность подключения учётных записей Gmail, Google Calendar,
          Яндекс Почты и Apple Calendar, а также чатов мессенджера Telegram посредством
          Telegram Business.
          {' '}
          Подключение осуществляется исключительно по инициативе Пользователя. Объём
          предоставляемого доступа определяется Пользователем при подключении и может быть отозван
          в любой момент через настройки Сервиса или соответствующего стороннего сервиса.
          {' '}
          Сервис вправе совершать от имени Пользователя следующие действия: направлять электронные
          письма, создавать, изменять и удалять события в подключённых календарях, направлять
          сообщения в чатах при активации соответствующей функции.
          {' '}
          Перед совершением действия, влекущего необратимые последствия, Сервис запрашивает
          подтверждение Пользователя. Ответственность за данные Пользователем инструкции
          и подтверждения несёт Пользователь.
        </Section>

        <Section title="7. Обработка сообщений в подключённых чатах">
          При подключении чатов Telegram на тарифе Pro Сервис обрабатывает новые сообщения
          в чатах, выбранных Пользователем, с целью выявления договорённостей и сроков.
          {' '}
          Пользователь самостоятельно определяет перечень подключаемых чатов и несёт
          ответственность за соблюдение прав иных участников переписки. История сообщений,
          предшествующая подключению, не обрабатывается.
        </Section>

        <Section title="8. Точность и характер ответов">
          Ответы Сервиса формируются автоматически и могут содержать неточности, включая
          фактические ошибки.
          {' '}
          Сервис не является источником профессиональных консультаций. Не следует полагаться
          на ответы Сервиса при принятии решений в области медицины, права, финансов и иных сферах,
          требующих специальных знаний. По вопросам, имеющим существенное значение, следует
          обращаться к квалифицированным специалистам.
        </Section>

        <Section title="9. Ограничение ответственности">
          Сервис предоставляется на условиях «как есть». Администрация не гарантирует
          бесперебойную и безошибочную работу Сервиса.
          <p>Администрация не несёт ответственности за:</p>
          <List items={[
            'прямые или косвенные убытки, возникшие вследствие использования либо невозможности использования Сервиса;',
            'неточности в ответах и рекомендациях Сервиса;',
            'действия, совершённые Сервисом на основании подтверждённых Пользователем инструкций;',
            'последствия сбоев в работе сторонних сервисов, включая мессенджер Telegram, поставщиков технологий обработки данных, почтовые и календарные сервисы, платёжные системы;',
            'утрату данных вследствие обстоятельств, находящихся вне разумного контроля Администрации.',
          ]} />
          Совокупная ответственность Администрации ограничивается суммой, уплаченной Пользователем
          за подписку в течение трёх месяцев, предшествующих возникновению основания
          для ответственности.
        </Section>

        <Section title="10. Интеллектуальная собственность">
          Программный код, дизайн, товарный знак и иные элементы Сервиса принадлежат Администрации.
          {' '}
          Содержание сообщений Пользователя принадлежит Пользователю. Администрация использует его
          исключительно в целях, определённых Политикой конфиденциальности.
          {' '}
          Пользователь вправе свободно использовать результаты, полученные посредством Сервиса.
        </Section>

        <Section title="11. Приостановление и прекращение доступа">
          Пользователь вправе прекратить использование Сервиса в любой момент, в том числе удалив
          учётную запись посредством команды /delete.
          {' '}
          Администрация вправе приостановить или прекратить доступ Пользователя к Сервису
          при нарушении настоящих Условий, а также при наличии оснований полагать, что действия
          Пользователя причиняют вред Сервису либо иным пользователям.
          {' '}
          При прекращении доступа по инициативе Администрации вследствие нарушения Условий
          уплаченные денежные средства возврату не подлежат.
        </Section>

        <Section title="12. Изменение Условий">
          Администрация вправе вносить изменения в настоящие Условия. Актуальная редакция
          размещается по адресу deloapp.online/terms. О существенных изменениях Пользователи
          уведомляются через Сервис.
          {' '}
          Продолжение использования Сервиса после вступления изменений в силу означает согласие
          с новой редакцией.
        </Section>

        <Section title="13. Применимое право и разрешение споров">
          К отношениям Сторон применяется законодательство Российской Федерации.
          {' '}
          Споры подлежат разрешению путём переговоров. Претензионный порядок является
          обязательным, срок рассмотрения претензии составляет тридцать календарных дней
          с момента получения.
          {' '}
          При недостижении согласия спор подлежит рассмотрению в суде в соответствии
          с законодательством Российской Федерации.
        </Section>

        <Section title="14. Контактная информация">
          Обращения направляются по адресу my@zakharovsem.ru либо через Telegram: @zakharovsemyon.
        </Section>
      </div>
    </div>
  )
}


function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-surface-1 border border-line-1 rounded-lg p-4">
      <p className="text-base font-medium text-ink mb-2">{title}</p>
      <div className="text-sm text-ink-1 leading-relaxed space-y-2">{children}</div>
    </div>
  )
}


function List({ items }: { items: string[] }) {
  return (
    <ul className="space-y-1">
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-2">
          <span className="mt-2 w-1 h-1 rounded-full bg-line-2 shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  )
}
